import { useIntl } from "react-intl";
import Box from "@mui/material/CardContent";
import Item from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import ggImage from "../img/GG.svg";
import balImage from "../img/BAL.svg";
import bvImage from "../img/BV.svg";
import briImage from "../img/BRI.png";
import yslImage from "../img/SL.png";
import amqImage from "../img/AMQ.png";

const Home = () => {
  const intl = useIntl();

  const Img = styled("img")({
    margin: 0,
    padding: 0,
    height: "auto",
  });

  return (
    <Box
      sx={{
        height: "80vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Grid container spacing={2}>
        <Grid
          item
          md={12}
          display="flex"
          justifyContent="center"
          sx={{ mb: 10 }}
        >
          <Img
            src={require("../img/kering_logo.png")}
            sx={{ maxWidth: "65%" }}
          />
        </Grid>
        <Grid item md={12} display="flex" justifyContent="center">
          <Grid item md={2} display="flex" justifyContent="center">
            <img width={120} src={amqImage} />
          </Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
        </Grid>

        <Grid item md={12} display="flex" justifyContent="center">
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center">
            <img width={120} src={balImage} />
          </Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
        </Grid>

        <Grid item md={12} display="flex" justifyContent="center">
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center">
            <img width={150} src={bvImage} />
          </Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
        </Grid>

        <Grid item md={12} display="flex" justifyContent="center">
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center">
            <img width={120} src={briImage} />
          </Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
        </Grid>

        <Grid item md={12} display="flex" justifyContent="center">
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center">
            <img width={120} src={ggImage} />
          </Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
        </Grid>

        <Grid item md={12} display="flex" justifyContent="center">
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center"></Grid>
          <Grid item md={2} display="flex" justifyContent="center">
            <img width={120} src={yslImage} />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Home;
